import React from "react";
import { DatagridRow } from "react-admin";

const MyRow = ({
  id,
  record,
  resource,
  basePath,
  children,
  highlightList,
  highlight_key,
  setRowRef,
  onMouseEnter,
  onMouseLeave,
  ...rest
}) => {
  const style = {
    border:
      "1px " +
      (highlightList.includes(record[highlight_key])
        ? "double black"
        : "solid transparent"),
  };

  if (basePath) {
    console.error("basepath found: " + basePath);
  }

  return (
    <DatagridRow
      id={id}
      record={record}
      resource={resource}
      ref={(refElem) => setRowRef && setRowRef(record, refElem)}
      onMouseEnter={() => onMouseEnter && onMouseEnter(record)}
      onMouseLeave={() => onMouseLeave && onMouseLeave(record)}
      sx={style}
      {...rest}
    >
      {React.Children.map(children, (field) =>
        field
          ? React.cloneElement(field, {
              record,
              resource,
            })
          : null
      )}
    </DatagridRow>
  );
};

MyRow.defaultProps = {
  highlightList: [],
};

export default MyRow;
